module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dropdown', {
    staticClass: "full-width",
    attrs: {
      "maxHeight": 250
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline dropdown-toggle btn-default full-width",
    attrs: {
      "slot": "button",
      "type": "button",
      "data-toggle": "dropdown"
    },
    slot: "button"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.passedFont.family) + "\n\t\t\t"), _c('i', {
    staticClass: "fa fa-angle-down pull-right"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu full-width",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_vm._l((_vm.allGoogleFonts), function(font) {
    return [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.emitFontFamily(font)
        }
      }
    }, [_vm._v(_vm._s(font.family))])])]
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42374098!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/FontPicker.vue
// module id = 424
// module chunks = 1